import { Field, FormikProps } from "formik";
import * as React from "react";
import { cx } from "@emotion/css";
import FieldSelect from "../../components/FieldSelect";
import { FormValues } from "../../support/FormValues";
import bootstrapStyles from "../../css/bootstrap.module.css";
import formGroupStyles from "../../css/formgroup.module.css";
import { AccountTypeEnum } from "../../support/AccountTypeEnum";
import { FieldNameEnum } from "../../support/FieldNameEnum";

interface TraditionalProps {
  formikBag: FormikProps<FormValues>;
}

const TraditionalToAccountTypeOptions = [
  AccountTypeEnum.TraditionalIRA,
  AccountTypeEnum.SEPIRA,
  AccountTypeEnum.SimpleIRA
];

export const Traditional = ({ formikBag: { values } }: TraditionalProps) => (
  <React.Fragment>
    <div className={bootstrapStyles.row}>
      <div className={bootstrapStyles["col-md-12"]}>
        <hr />
      </div>
    </div>
    <div className={cx(bootstrapStyles.row)}>
      <div className={bootstrapStyles["col-md-6"]}>
        <Field
          name={FieldNameEnum.toAccountType}
          label="Transfer Account To"
          options={TraditionalToAccountTypeOptions}
          component={FieldSelect}
          removeDefaultSelectOption
        />
      </div>
    </div>
    <div className={bootstrapStyles.row}>
      <div className={bootstrapStyles["col-md-6"]}>
        {values.toAccountType === AccountTypeEnum.SimpleIRA && (
          <div id="SimpleDisclaimer" className={formGroupStyles["form-group"]}>
            <em>
              If this account does not meet the 2-yr contribution rule we will
              open a Traditional IRA on your behalf to receive this transfer.
            </em>
          </div>
        )}
      </div>
    </div>
  </React.Fragment>
);
